const normalizeHeader = (header: string) => {
  // clean up invisible chars, quotes, and trim
  const cleaned = header
    .replace(/^\uFEFF|[\u200B\u200C\u00A0]/g, '')
    .replace(/["']/g, '')
    .replace(/[\r\n\t]/g, '')
    .trim();

  return cleaned.toLowerCase().split(' ').join('').split('-').join('');
};

export const getIsRecognizedHeaderPredicate = (header: string) => (recHeading: string) => {
  return normalizeHeader(header) === normalizeHeader(recHeading);
};
